const target = {
  state: () => ({
    barIndex: 0,
    targetStartDate: '',
    targetEndDate: '',
    targetDeptId: '',
    targetDeptName: '',
    targetNavCode: 0,
  }),
  mutations: {
    SET_TARGET_STATE (state, payload) {
      const { key, value } = payload
      state[key] = value
    },
  },
  getters: {
    getBarIndex: state => state.barIndex,
    getTargetStartDate: state => state.targetStartDate,
    getTargetEndDate: state => state.targetEndDate,
    getTargetDeptId: state => state.targetDeptId,
    getTargetDeptName: state => state.targetDeptName,
    getTargetNavCode: state => state.targetNavCode
  },
  actions: {

  },
}

export default target
